import { render, staticRenderFns } from "./ReferenceTitle.vue?vue&type=template&id=483ad040"
import script from "./ReferenceTitle.vue?vue&type=script&lang=js"
export * from "./ReferenceTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports